import { Divider } from 'antd';
import { openModal } from './openModal';

export const openModalForm = config => {
  const modal = openModal({
    content: (
      <>
        <Divider type="horizontal" className="m-0 !p-0" />
        {config.form}
        <Divider type="horizontal" className="m-0 !p-0" />
      </>
    ),
    centered: true,
    width: 538,
    classNames: {
      header: '!px-16 !py-12 !m-0',
      body: '!p-0',
      footer: '!px-16 !py-12 gap-16 items-end flex justify-end',
    },
    ...config,
  });

  return modal;
};
